<template>
    <div class="tab-content-container">
        <div class="tab-header-container">
            <h2 class="form-label">Езици</h2>
            <LiteButton @click.native="editButtonClicked"
                        class="edit-button"
                        v-show="!shouldEdit"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <LiteButton @click.native="editButtonClicked"
                        style="font-size: 27px;"
                        class="edit-button"
                        v-show="shouldEdit"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <div class="item-container very-light-shadow"
             v-for="language in workerLanguagesCache" :key="language.languageId">

            <p class="item-label" v-text="language.language"></p>

            <LiteButton @click.native="removeLanguage(language)"
                        class="edit-button delete-icon"
                        v-show="shouldEdit"
                        :hoverColor="'red'"
                        :icon="'far fa-trash-alt'">
            </LiteButton>

            <div class="last-modified-container">
                <p class="last-modified-date" v-text="getWorkerLanguagesLastModifiedDate(language)"></p>
                <p class="last-modified-name" v-text="getWorkerLanguagesLastModifiedBy(language)"></p>
            </div>
        </div>

        <div class="add-item-container" v-if="shouldEdit">
            <SelectDropDown class="item-dropdown"
                            :id="'language'"
                            :name="'language'"
                            @selection-change="selectedLanguage"
                            :options="languages"
                            :label="'Добавяне на език'"
                            :placeholder="'Изберете език'">
            </SelectDropDown>
            <LiteButton @click.native="addLanguage"
                        class="add-item-icon"
                        :hoverColor="'green'"
                        :icon="'far fa-plus-square'">
            </LiteButton>
        </div>

        <Button class="save-button"
                v-if="shouldEdit"
                @click.native="saveLanguages"
                :color="'green'"
                :text="'Запази'"
                :icon="'fa fa-save'"></Button>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Button from "@/shared/components/button/Button";
    import LiteButton from "@/shared/components/button/LiteButton";
    import workerService from "@/services/worker.service";
    import mapperService from "@/services/mapper.service";
    import {cloneDeep} from 'lodash';
    import sharedService from "@/services/shared.service";
    import SelectDropDown from "@/shared/components/form/SelectDropDown";

    export default {
        name: "WorkerLanguagesForm",
        components: {SelectDropDown, LiteButton, Button},
        created() {
            this.workerLanguagesCache = cloneDeep(this.workerLanguages);
            sharedService.fetchAllLanguages()
                .then(({data}) => {
                    this.allLanguages = data;
                    this.setLanguages();
                });
        },
        data() {
            return {
                workerId: this.$route.params.id,
                shouldEdit: false,
                workerLanguagesCache: cloneDeep(this.workerLanguages),
                currentLanguage: null,
                languages: [],
                allLanguages: []
            }
        },
        methods: {
            selectedLanguage(value) {
                this.currentLanguage = value.currentValue;
            },
            editButtonClicked() {
                this.shouldEdit = !this.shouldEdit;
                this.workerLanguagesCache = cloneDeep(this.workerLanguages);
                this.setLanguages();
            },
            addLanguage() {
                if (this.currentLanguage) {
                    this.workerLanguagesCache.push({
                        languageId: this.currentLanguage.id,
                        language: this.currentLanguage.language,
                        workerId: this.workerId
                    });
                    this.currentLanguage = null;
                    this.setLanguages();
                }
            },
            setLanguages() {
                const workerLanguagesIds = this.workerLanguagesCache.map(temp => temp.languageId);
                this.languages = cloneDeep(this.allLanguages)
                    .filter(temp => !workerLanguagesIds.includes(temp.id))
                    .map(temp => {
                        temp.name = temp.language;
                        return temp;
                    });
            },
            saveLanguages() {
                workerService.updateLanguages(this.workerId, this.workerLanguagesCache)
                    .then(({data}) => {
                        this.$store.commit('setWorkerLanguages', data);
                        this.shouldEdit = false;
                    })
                    .catch(() => alert("Грешка, моля опитайте отново!"));
            },
            getWorkerLanguagesLastModifiedBy(education) {
                return mapperService.getLastModifiedBy(education);
            },
            getWorkerLanguagesLastModifiedDate(education) {
                return mapperService.getLastModifiedDate(education);
            },
            removeLanguage(language) {
                this.workerLanguagesCache = this.workerLanguagesCache.filter((temp) => temp.languageId !== language.languageId);
                this.setLanguages();
            }
        },
        computed: {
            ...mapGetters(['workerLanguages'])
        },
        watch: {
            workerLanguages: {
                handler(newVal) {
                    if (newVal) {
                        this.workerLanguagesCache = cloneDeep(newVal);
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .add-item-container {
        margin-top: 50px;
        width: 100%;
        display: inline-block;
    }

    .item-dropdown {
        width: 400px;
        float: left;
    }

    .add-item-icon {
        font-size: 40px;
        float: left;
        width: fit-content;
        height: 100%;
        margin: 36px;
        color: var(--slight-light-green);
    }

</style>